import Page from './Page.jsx';

export default Page;


// WEBPACK FOOTER //
// ./src/components/Page/index.jsx